import React from 'react'
import DisplayExitClient from '../components/clientInfo/DisplayExitClient'


export default function Reports() {
  return (
    <div className="layout-body">
      <DisplayExitClient />
    </div>
  )
}
